import { render } from "./SerialModal.vue?vue&type=template&id=547e7455&scoped=true"
import script from "./SerialModal.vue?vue&type=script&lang=js"
export * from "./SerialModal.vue?vue&type=script&lang=js"

import "./SerialModal.vue?vue&type=style&index=0&id=547e7455&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547e7455"]])

export default __exports__